import { styled } from '@mui/material/styles';

export const Horizontal = styled('div')`
  display: flex;
  padding: 24px;
  justify-content: space-between;
`;

export const Left = styled('div')`
  display: inline-flex;
  gap: 12px;
`;

export const Right = styled('div')`
  display: inline-flex;
  justify-content: flex-end;
  gap: 12px;
`;
